import { Platform } from 'react-native';
import { File, Paths } from 'expo-file-system';
import * as Sharing from 'expo-sharing';

/**
 * Sample CSV downloads for the bulk importers. Realistic-looking rows
 * the user can open in Excel/Numbers/Google Sheets, edit, then upload.
 * On web we trigger a Blob download; on native we share via the
 * platform share sheet.
 */

export const INVENTORY_SAMPLE_CSV = `name,room,category,brand,model,serial,vendor,purchase date,purchase price,current value,condition,insured,notes
LG OLED TV,Living Room,Electronics,LG,OLED65C2,512MAQQ8U749,Best Buy,2023-05-12,1799.99,1300,excellent,yes,Wall-mounted; data plate on back
Whirlpool Dishwasher,Kitchen,Appliances,Whirlpool,WDT730PAHZ,F23901002,Home Depot,2022-08-04,749.00,500,good,yes,Installed by Home Depot crew
Dyson V11 Vacuum,Closet,Cleaning,Dyson,V11 Torque Drive,SV14,Costco,2021-11-22,599.99,300,fair,no,Replacement battery 2024
Weber Spirit II Grill,Patio,Outdoor,Weber,Spirit II E-310,4002B,Lowes,2020-04-30,549.00,200,fair,no,Cover stored in shed
Patagonia Down Jacket,Master Bedroom,Clothing,Patagonia,Down Sweater,,REI,2019-12-15,229.00,150,good,no,Insurance schedule item`;

export const EXPENSE_SAMPLE_CSV = `title,category,vendor,amount,paid on,recurring,tax deductible,notes
March electric bill,Utilities,DTE Energy,142.18,2026-03-05,monthly,no,Higher than usual — cold snap
Home insurance premium,Insurance,State Farm,1480.00,2026-01-12,annual,no,Policy #HO-123456
Property tax (summer),Taxes,Genesee County,2310.50,2026-07-15,annual,yes,Receipt in Media
HVAC tune-up,Repairs,Comfort Pro Heating,189.00,2026-04-02,annual,no,Filter replaced, no issues found
Lawn fertilization (spring),Lawn,TruGreen,89.00,2026-03-22,recurring,no,First of 4 visits
Mortgage payment,Mortgage,Wells Fargo,2150.00,2026-03-01,monthly,no,Principal + interest only
Internet,Utilities,Comcast,89.99,2026-03-08,monthly,no,Gigabit plan`;

export function inventorySampleFilename(): string {
  return 'homestead-inventory-sample.csv';
}

export function expenseSampleFilename(): string {
  return 'homestead-expenses-sample.csv';
}

/**
 * Download a CSV blob on web, or share it via the platform share sheet
 * on native. Both branches accept a filename hint.
 */
export async function downloadCsvSample(content: string, filename: string): Promise<void> {
  if (Platform.OS === 'web') {
    // eslint-disable-next-line no-undef
    const blob = new Blob([content], { type: 'text/csv' });
    // eslint-disable-next-line no-undef
    const url = URL.createObjectURL(blob);
    // eslint-disable-next-line no-undef
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    // eslint-disable-next-line no-undef
    setTimeout(() => URL.revokeObjectURL(url), 1500);
    return;
  }
  try {
    const file = new File(Paths.cache, filename);
    file.create();
    file.write(content);
    const canShare = await Sharing.isAvailableAsync();
    if (canShare) {
      await Sharing.shareAsync(file.uri, { mimeType: 'text/csv' });
    }
  } catch (err) {
    console.warn('downloadCsvSample failed', err);
  }
}
